import { doc, DocumentSnapshot, getDoc, setDoc } from 'firebase/firestore';

import { CourseProgressState } from '../../redux/slice/user-course';
import logger from '../logger';

import { getFirestoreDatabase } from './configure';
import { DatabaseTable } from './database.types';
import { getIdForFormRecord } from './database.utils';

const database: DatabaseTable = DatabaseTable.USER_COURSE_PROGRESS;
/**
 * upsert a record into the career readiness responses collection
 */
async function updateRecord<T extends Record<string, unknown>>(dto: T): Promise<void> {
  const recordId: string = await getIdForFormRecord();
  await setDoc(doc(getFirestoreDatabase(), database, recordId), dto, {
    merge: true,
  });
}

/**
 * retrieves previously stored course progress values if available
 */
export async function getCourseProgressValues(): Promise<CourseProgressState> {
  try {
    const recordId: string = await getIdForFormRecord();
    const result: DocumentSnapshot<CourseProgressState> = await getDoc(
      doc(getFirestoreDatabase(), database, recordId),
    );
    return result.data() ?? {};
  } catch (e) {
    logger.error('Failed to retrieve user course progress values.', e);
    throw e;
  }
}

/**
 * updates the career readiness assessment
 */
export async function updateCourseProgress(dto: CourseProgressState): Promise<void> {
  try {
    await updateRecord(dto);
    logger.debug('Saved user course progress.');
  } catch (e) {
    logger.error('Failed to update user course progress.', e);
    throw e;
  }
}
